import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.element.getBoundingClientRect();

    this.element.classList.remove('step-transition-none');
    this.element.classList.add('step-transition', 'step-visible');
    this.element.classList.remove('step-fade-out', 'step-slide-left', 'step-slide-right');
  }
}
